import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CustomerPortalDbService } from "../services/customer-portal-db.service";
import { CustomerLocationEffects } from "./effects/customer-location.effects";
import { reducer } from "./reducer/customer-location.reducer";

@NgModule({
    imports: [
        StoreModule.forFeature("customer-location", reducer),
        EffectsModule.forFeature([CustomerLocationEffects]),
    ],
    providers: [CustomerPortalDbService],
})
export class CustomerPortalStoreModule {}
